import { createAction } from '@reduxjs/toolkit';
import { site } from 'lib/src/shared/enums/site';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { ChallengeGroup } from 'src/types/shared/ChallengeGroup';

export const createChallengeGroupRequest = createAction('createChallengeGroupRequest');
export const createChallengeGroupSuccess = createAction<ChallengeGroup>(
    'createChallengeGroupSuccess',
);
export const createChallengeGroupFailure = createAction('createChallengeGroupFailure');

export const createChallengeGroup = (postBody: PostBody) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(createChallengeGroupRequest());
    try {
        const { data } = await api.post<PostBody, ChallengeGroup>(
            'admin/challengeGroups/create',
            postBody,
        );

        dispatch(createChallengeGroupSuccess(data));
    } catch (e: any) {
        handleApiErrors(dispatch, createChallengeGroupFailure, e);
    }
};

type PostBody = {
    name: string;
    viewerIDs: number[];
    adminIDs: number[];
    site: site;
};
